import { graphqlAjax } from '..'
import { gql } from 'apollo-boost'

export default {
  /* Query */
  getAllExchanges: params => {
    const query = gql`
      query($in: ExchangeFilter!) {
        allExchanges(in: $in) {
          data {
            # date
            hour
            minute
            exchange
            manual_exchange
            crawler_type
          }
          meta {
            total
          }
        }
      }
    `
    return graphqlAjax('get', query, params)
  },
  getAllSettings: params => {
    const query = gql`
      query($filter: Boolean) {
        allSettings(_: $filter) {
          exchange_rate_differences
          system_maintenance_account_white_list
          system_maintenance_operator_announcement
          system_maintenance_operator_announcement_switch
          system_maintenance_operator_switch
          system_maintenance_fenko_announcement
          system_maintenance_fenko_announcement_switch
          system_maintenance_fenko_switch
          report_sender_email
          report_email_list
          exchange_rate_remark
          exchange_rate_adjustment
          exchange_rate_base
          exchange_rate_upper_bound_set_type
          exchange_rate_upper_bound
          exchange_rate_lower_bound_set_type
          exchange_rate_lower_bound
          exchange_manual_setting
        }
      }
    `
    return graphqlAjax('get', query, params)
  },
  getSystemInfo: params => {
    const query = gql`
      query($filter: Boolean) {
        allSettings(_: $filter) {
          system_maintenance_operator_announcement
          system_maintenance_fenko_announcement
          system_maintenance_operator_announcement_switch
          system_maintenance_fenko_announcement_switch
          system_maintenance_operator_switch
          system_maintenance_fenko_switch
          exchange_rate_remark
          exchange_rate_adjustment
          exchange_rate_base
          exchange_rate_upper_bound_set_type
          exchange_rate_upper_bound
          exchange_rate_lower_bound_set_type
          exchange_rate_lower_bound
          exchange_manual_setting
        }
      }
    `
    return graphqlAjax('get', query, params)
  },
  getCrawlExchange: bool => {
    const payload = { in: { is_crawl: bool } }
    const mutation = gql`
      mutation($in: CrawlExchangeInput!) {
        crawlExchange(in: $in)
      }
    `
    return graphqlAjax('post', mutation, payload)
  },
  getListManualExchangeHistories: params => {
    const query = gql`
      query($in: ManualExchangeHistoryFilter!) {
        listManualExchangeHistories(in: $in) {
          data {
            username
            nickname
            exchange
            date
          }
          meta {
            total
          }
        }
      }
    `
    return graphqlAjax('get', query, params)
  },
  /* Mutation */
  // [XO9.1 / XO9.3] 更新系統參數設定
  // 全必填，不修改則給空字串
  batchUpdateSettings: params => {
    // 防呆，預防有參數忘記給
    const defaultParams = {
      exchange_rate_differences: '',
      system_maintenance_account_white_list: '',
      system_maintenance_operator_announcement: '',
      system_maintenance_operator_announcement_switch: '',
      system_maintenance_operator_switch: '',
      system_maintenance_fenko_announcement: '',
      system_maintenance_fenko_announcement_switch: '',
      system_maintenance_fenko_switch: '',
      report_sender_email: '',
      report_email_list: '',
      exchange_rate_remark: '',
      exchange_rate_adjustment: '',
      exchange_rate_base: '',
      exchange_rate_upper_bound_set_type: '',
      exchange_rate_upper_bound: '',
      exchange_rate_lower_bound_set_type: '',
      exchange_rate_lower_bound: '',
      exchange_manual_setting: ''
    }
    const payload = { in: { ...defaultParams, ...params.in } }
    const mutation = gql`
      mutation($in: SettingsInput!) {
        batchUpdateSettings(in: $in) {
          exchange_rate_differences
          system_maintenance_account_white_list
          system_maintenance_operator_announcement
          system_maintenance_operator_announcement_switch
          system_maintenance_operator_switch
          system_maintenance_fenko_announcement
          system_maintenance_fenko_announcement_switch
          system_maintenance_fenko_switch
          report_sender_email
          report_email_list
          exchange_rate_remark
          exchange_rate_adjustment
          exchange_rate_base
          exchange_rate_upper_bound_set_type
          exchange_rate_upper_bound
          exchange_rate_lower_bound_set_type
          exchange_rate_lower_bound
          exchange_manual_setting
        }
      }
    `
    return graphqlAjax('post', mutation, payload)
  }
}
